<template>
  <!-- 物料管理 -->
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item prop="productName" label="物料信息">
          <el-input
            v-model="listForm.productName"
            placeholder="请输入名称或编码"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="物料类型" prop="productionProductTypeId">
          <el-select v-model="listForm.productionProductTypeId">
            <el-option label="全部" value=""> </el-option>
            <el-option
              v-for="(item, index) of productTypeList"
              :key="index"
              :label="item.productTypeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物料品牌" prop="productionBrandId">
          <el-autocomplete
            class="inline-input"
            v-model="brandName"
            :fetch-suggestions="querySearch"
            placeholder="请输入品牌"
            @select="item => handleSelect(item)"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.productBrandName }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item prop="lockFlag" label="状态">
          <el-select v-model="listForm.lockFlag" clearable placeholder="请选择">
            <el-option label="全部" value=""> </el-option>
            <el-option label="正常" value="1"> </el-option>
            <el-option label="禁用" value="0"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="10" class="button-box">
      <el-col :span="1.5" class="add-btn">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <el-col :span="1.5" class="add-btn">
        <el-button
          type="primary"
          icon="el-icon-download"
          :disabled="productIds.length == 0"
          @click="exportXml"
          >导出物料信息xml</el-button
        >
        <el-checkbox-group
          v-show="exportAll"
          v-model="exportState"
          style="display: inline-block; margin-left: 20px"
        >
          <el-checkbox true-label="0">仅导出本页数据</el-checkbox>
          <el-checkbox true-label="1">导出全部数据</el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-table
      :data="list"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      @select-all="handleSelectAll"
      border
    >
      <el-table-column type="selection" width="80" align="center">
      </el-table-column>
      <el-table-column
        prop="productName"
        label="物料名称"
        min-width="200"
        align="center"
      >
        <!-- <template slot-scope="scope">
          <span
            style="cursor: pointer; color: #409eff"
            @click="rowDetail(scope.row)"
            >{{ scope.row.productName }}</span
          >
        </template> -->
      </el-table-column>
      <el-table-column
        prop="productCode"
        label="物料编号"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="productTypeName"
        label="物料类型"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="specifications"
        label="物料规格"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="productBrand"
        label="所属品牌"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="lockFlag"
        label="状态"
        align="center"
        min-width="80"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.lockFlag"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
            @change="statusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      
      <el-table-column
        label="操作"
        align="center"
        min-width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)"
          >
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="800px"
      @close="dialogEditClose"
      ><el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        label-width="125px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="物料名称" prop="productName">
              <el-input v-model="editForm.productName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物料编号" prop="productCode">
              <el-input :disabled="isDisabled" v-model="editForm.productCode" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="展示名称" prop="kindlyReminder">
              <el-input
                :disabled="isDisabled"
                v-model="editForm.kindlyReminder"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="产地" prop="productionPlace">
              <el-input
                :disabled="isDisabled"
                v-model="editForm.productionPlace"
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="品牌" prop="productBrand">
              <el-input
                :disabled="isDisabled"
                v-model="editForm.productBrand"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格（kg）" prop="specifications">
              <el-input
                :disabled="isDisabled"
                v-model="editForm.specifications"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="配比" prop="ratio">
              <el-input :disabled="isDisabled" v-model="editForm.ratio" />
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="editForm.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="产品详情"
      :visible.sync="dialogDetail"
      :close-on-click-modal="false"
      width="800px"
      @close="handleDetailClose"
    >
      <el-form ref="detailForm" :model="detailForm" label-width="125px">
        <div class="label-line">基本信息</div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="产品类型" prop="productionProductTypeId">
              <treeselect
                disabled
                :options="productTypeList"
                v-model="detailForm.productionProductTypeId"
                :normalizer="normalizer"
                :show-count="true"
                :clearable="false"
                placeholder="请选择"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productName">
              <el-input
                disabled
                v-model="detailForm.productName"
                placeholder="请输入产品名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品编号" prop="productCode">
              <el-input
                disabled
                v-model="detailForm.productCode"
                placeholder="请输入产品编号"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="包装比例" prop="packingRatio">
              <el-input
                disabled
                v-model="detailForm.packingRatio"
                placeholder="请输入包装比例"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格" prop="specifications">
              <el-input
                disabled
                v-model="detailForm.specifications"
                placeholder="请输入产品规格"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                disabled
                v-model="detailForm.remark"
                type="textarea"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogDetail = false">关 闭</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import {
  getProductPageList,
  getProductTypeList,
  getBrandList,
  editProduct,
  exportProductList,
  saveProduct
} from "@/common/api.js";
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  props: {},
  data() {
    return {
      loading: false,
      listForm: {
        pageNum: 1,
        pageSize: 10,
        productName: "",
        productionBrandId: "",
        lockFlag: "",
        productionProductTypeId: ""
      },
      total: 0,
      list: [],
      // 导出
      exportAll: false,
      exportState: "0",
      productIds: [],
      brandList: [],
      productTypeList: [], //类型列表
      brandName: "",
      detailForm: {
        //详情
        productionProductTypeId: null, //产品类型
        productName: "", //产品名称
        companyId: "", //企业id
        productCode: "", //产品编号
        packingRatio: "", //包装比例
        specifications: "",
        propertyDeploy: [], //属性
        remark: ""
      },
      dialogAdd: false,
      isDisabled:false,
      dialogDetail: false,
      title: "",
      normalizer(node) {
        if (
          node.productionChildList == null ||
          node.productionChildList.length == 0
        ) {
          delete node.productionChildList;
        }
        return {
          id: node.id,
          label: node.productTypeName,
          children: node.productionChildList
        };
      },
      editForm: {
        id: "",
        productName: "", //产品名称
        productTypeName: "", //产品类型
        productCode: "", //产品编号
        specifications: "", //规格 //净含量
        productBrand: "", //品牌
        productId: "",
        remark: "", //物料描述
        productionPlace: "", //产地
        ratio: "", //配比
        packaging: "", //包装
        kindlyReminder: "" //展示名称
      },
      dialogEdit: false,
      rules: {
        productName: [
          { required: true, message: "请输入物料名称", trigger: "blur" }
        ],
        productCode: [
          { required: true, message: "请输入物料编号", trigger: "blur" }
        ],
      }
    };
  },
  methods: {
    // 物料列表
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      getProductPageList(params).then(res => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.pageInfo.list;
          this.total = res.pageInfo.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 物料类型列表
    getProductTypeList() {
      var params = {};
      getProductTypeList(params).then(res => {
        if (res.errorCode == 200) {
          this.productTypeList = res.data;
        }
      });
    },
    //物料品牌列表
    getBrandList() {
      getBrandList({ data: 1 }).then(res => {
        if (res.errorCode == 200) {
          this.brandList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.brandList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.productBrandName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    // 新增物料
    handleAdd() {
      this.dialogEdit = true;
      this.title = "新增";
    },
    dialogEditClose() {
      this.editForm = {
        id: "",
        productName: "", //产品名称
        productTypeName: "", //产品类型
        productCode: "", //产品编号
        specifications: "", //规格 //净含量
        productBrand: "", //品牌
        productId: "",
        remark: "", //物料描述
        productionPlace: "", //产地
        ratio: "", //配比
        packaging: "", //包装
        kindlyReminder: "" //展示名称
      };
    },
    //编辑
    handleEdit(row) {
      this.title="编辑"
      this.isDisabled = false;
      this.dialogEdit = true;
      this.editForm = {
        id: row.id,
        productName: row.productName, //产品名称
        productTypeName: row.productTypeName, //产品类型
        productCode: row.productCode, //产品编号
        specifications: row.specifications,
        productBrand: row.productBrand,
        productId: row.productId,
        remark: row.remark || "",
        productionPlace:row.productionPlace, //产地
        ratio:  row.ratio, //配比
        packaging: row.packaging, //包装
        kindlyReminder:  row.kindlyReminder //展示名称
      };
    },
    saveAddOrEdit() {
      let params = this.editForm;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          saveProduct(params).then(res => {
            if (res.errorCode == 200) {
              this.$message({
                type: "success",
                message: "保存成功"
              });
              this.dialogEdit = false;
              this.getPageList();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    handleSelect(item) {
      console.log(item);
      this.brandName = item.productBrandName;
      this.listForm.productionBrandId = item.id;
    },
    // 选中导出的物料
    handleSelectionChange(val) {
      console.log(val);
      this.productIds = val;
      if (val.length == this.list.length) {
        this.exportAll = true;
      } else {
        this.exportAll = false;
      }
    },
    handleSelectAll(val) {
      console.log(val);
      if (val.length > 0) {
        this.exportAll = true;
      } else {
        this.exportAll = false;
      }
    },
    // 导出
    exportXml() {
      var str = "";
      if (this.exportAll && this.exportState == 1) {
        str = "";
      } else {
        for (var i = 0; i < this.productIds.length; i++) {
          str += this.productIds[i].productId + ",";
        }
        if (str.length > 0) {
          str = str.substr(0, str.length - 1);
        }
      }
      var data = {
        productIds: str
      };
      this.$message({
        message: "开始下载，请稍后",
        type: "success"
      });
      exportProductList(data)
        .then(res => {
          const blob = new Blob([res]);
          console.log(res);
          const fileName = "物料列表.xml";
          const elink = document.createElement("a"); // 创建a标签
          elink.download = fileName; // 为a标签添加download属性
          // a.download = fileName; //命名下载名称
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click(); // 点击下载
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink); // 释放标签
          this.loadingExt = false;
          axios.defaults.responseType = "json";
        })
        .catch(res => {
          axios.defaults.responseType = "json";
        });
    },
    //修改状态
    statusChange(row) {
      const h = this.$createElement;
      let text = "";
      if (row.lockFlag == 0) {
        text = "禁用";
      } else if (row.lockFlag == 1) {
        text = "启用";
      }
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("h3", null, '是否将 "' + text + '" 该产品?', "警告")
        ]),
        showCancelButton: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              productId: row.productId,
              lockFlag: row.lockFlag
            };
            editProduct(params).then(res => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
              } else {
                this.$message.error(res.msg);
                if (row.lockFlag == 1) {
                  row.lockFlag = 0;
                } else if (row.lockFlag == 0) {
                  row.lockFlag = 1;
                }
              }
            });
          } else {
            done();
            if (row.lockFlag == 1) {
              row.lockFlag = 0;
            } else if (row.lockFlag == 0) {
              row.lockFlag = 1;
            }
          }
        }
      })
        .then(action => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 查询
    searchList() {
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.$refs["listForm"].resetFields();
        this.listForm = {
          pageNum: 1,
          pageSize: 10,
          productName: "",
          productionBrandId: "",
          lockFlag: "",
          productionProductTypeId: ""
        };
        this.brandName = "";
        this.getPageList();
      });
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    }
  },
  mounted() {
    this.getPageList();
    this.getProductTypeList(); //产品类型列表
    this.getBrandList();
  },
  beforeDestroy() {
    //清除定时器
    clearInterval(this.task);
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .title {
    padding: 0 50px;
    .search {
      float: right;
    }
  }
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .sync-box {
    float: right;
    margin-right: 20px;
    color: #f56c6c;
    font-size: 14px;
    text-align: right;
  }
  .sync-box1 {
    color: #333333;
  }
  .dialog-button {
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
    margin-bottom: 15px;
  }
  .label-line {
    border-left: 3px solid #409eff;
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
  }
  .avatar-uploader {
    /deep/.el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
    }
    .avatar {
      width: 120px;
      height: 120px;
      display: block;
    }
  }
  .button-box {
    padding: 15px !important ;
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 10px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
    .standard-code {
      font-size: 14px;
      color: #8f8f8f;
      display: inline-block;
      line-height: 40px;
      margin-left: 10px;
    }
    .el-select {
      width: 100%;
    }
    .expiry-date /deep/.el-form-item__content {
      margin-left: 10px !important;
    }
  }
  /deep/.vue-treeselect__control {
    height: 40px;
    line-height: 40px;
  }
  /deep/.vue-treeselect__placeholder,
  /deep/.vue-treeselect__single-value {
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/system/materialCenter/materialManage.vue